import { fireBIEvent } from 'public/bi-events.js'; 
import wixLocation from 'wix-location';

$w.onReady(function () {

    ////////////////////////////////////////////////////////

    $w('#POSExpert1').onClick(() => {
        const biFields = {
            button_name: "talk_to_expert_header",
            topic: "Talk to a POS Expert",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#WatchVideo1').onClick(() => {
        const biFields = {
            button_name: "watch_video_header",
            topic: "Watch Video",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#POSExpert2').onClick(() => {
        const biFields = {
            button_name: "talk_to_expert_first_fold",
            topic: "Talk to a POS Expert",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#ShopPOS1').onClick(() => {
        const biFields = {
            button_name: "shop_pos_first_fold",
            topic: "Shop POS",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#POSExpert3').onClick(() => {
        const biFields = {
            button_name: "talk_to_expert_second_fold",
            topic: "Talk to a POS Expert",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#ShopPOS2').onClick(() => {
        const biFields = {
            button_name: "shop_pos_second_fold",
            topic: "Shop POS",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#POSExpert4').onClick(() => {
        const biFields = {
            button_name: "talk_to_expert_third_fold",
            topic: "Talk to a POS Expert",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#GetStarted1').onClick(() => {
        const biFields = {
            button_name: "get_started_third_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#ExploreFeatures').onClick(() => {
        const biFields = {
            button_name: "explore_features_fourth_fold",
            topic: "Explore All Features",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#WatchVideo2').onClick(() => {
        const biFields = {
            button_name: "watch_video_testimonial_fold",
            topic: "Watch Video",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#POSExpert5').onClick(() => {
        const biFields = {
            button_name: "talk_to_expert_how_it_works_fold",
            topic: "Talk to a POS Expert",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#GetStarted2').onClick(() => {
        const biFields = {
            button_name: "get_started_how_it_works_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#GetStartedCloser').onClick(() => {
        const biFields = {
            button_name: "get_started_bottom_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

});